import React from 'react';
import UserInfo, { useUserInfo } from '../common/UserInfo';
import WordHistory from './Vocabulary/WordHistory';
import LeftMenu from '../common/LeftMenu';
import styles from '@/assets/styles/StudyCenter.module.less';

export const History: React.FC = () => {
  const userInfo = useUserInfo();
  return <WordHistory userInfo={userInfo} />;
}

const SearchHistory: React.FC = () => {
  return <main className={styles.studyCenterContainer}>
  <LeftMenu />
  <UserInfo title="查词记录">
    <History />
  </UserInfo>
  </main>;
};

export default SearchHistory;
